<!-- eslint-disable vue/require-component-is -->
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="$t('menuitems.dashboards.text')" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            v-if="hasAccessAll(['dashboard-scheduler:read'])"
            :icon="'icon-outline_calendar'"
            variant="secondary"
            :text="$t('dashboard.deliverSummary.title')"
            @click="$router.push({ name: 'Dashboard Scheduler' })"
          />
        </div>
      </div>
    </div>
    <Tabs :tabIndex="tabIndex" @update:tabIndex="($event) => updateTab($event)">
      <template v-for="tab in tabs">
        <Tab
          :key="tab.key"
          :hash="tab.hash"
          :title="tab.title"
          :isNewSubmodule="Object.keys(tab).includes('isNewSubmodule') && tab.isNewSubmodule()"
        >
          <component :is="tab.content" :id="tab.key" :link="tab.link" />
        </Tab>
      </template>
    </Tabs>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import { mapGetters } from 'vuex'

import Layout from '../../layouts/main'
import Tabs from './components/Tabs'
import Tab from './components/Tab'
import PageHeader from '@/components/page-header-v2'
import CustomDashboard from './contents/CustomDashboard'
import McButton from '@/components/McButton'
import dashboardTabs from './lib/constants/dashboard-tabs'
import { MixPanel } from '@/mixin/mixpanel'
import { getCustomDashboard } from '@/services/rest-api/lib/dashboard/custom.js'

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Tabs,
    Tab,
    PageHeader,
    McButton,
  },
  mixins: [MixPanel],
  data() {
    return {
      tabIndex: 0,
      timerMixpanel: null,
      customTabs: [],
    }
  },
  computed: {
    ...mapGetters({
      // used in dashboardTabs
      hasAccessAll: 'identity/hasAccessAll',
      hasAccess: 'identity/hasAccess',
      isNewSubmodule: 'identity/isNewSubmodule',
    }),
    tabs() {
      const tabs = dashboardTabs(this).filter((tab) => tab.showTab)

      if (this.customTabs.length > 0) {
        this.customTabs.forEach((tab) => {
          tabs.push(tab)
        })
      }

      return tabs
    },
  },
  watch: {
    tabIndex(newValue) {
      if (this.tabs[newValue].hash === this.$route.hash) return
      this.$router.push(this.tabs[newValue].hash)
    },
  },
  beforeMount() {
    // Match router hash to current active tab
    const idx = this.tabs.findIndex((tab) => tab.hash === this.$route.hash && tab.showTab)
    if (idx !== -1) this.tabIndex = idx
  },
  mounted() {
    if (this.$route.path === '/chat') {
      window.fcWidgetMessengerConfig = {
        open: true,
      }
      window.fcWidget.open()
    }

    this.sendTrack()

    if (!this.hasAccess(['custom_dashboard:read'])) return

    this.getCustomDashboard()
  },
  methods: {
    updateTab(event) {
      this.tabIndex = event
      this.sendTrack()
    },
    sendTrack() {
      if (this.tabIndex !== null) {
        switch (this.tabIndex) {
          case 0:
            if (this.timerMixpanel) clearTimeout(this.timerMixpanel)
            this.track('View Dashboard Kendaraan')
            this.timerMixpanel = setTimeout(() => {
              this.track('View Dashboard Kendaraan in 10 Seconds')
            }, 10000)
            break
          case 1:
            if (this.timerMixpanel) clearTimeout(this.timerMixpanel)
            this.track('View Dashboard Rangkuman')
            this.timerMixpanel = setTimeout(() => {
              this.track('View Dashboard Rangkuman in 10 Seconds')
            }, 10000)
            break
          case 2:
            if (this.timerMixpanel) clearTimeout(this.timerMixpanel)
            this.track('View Dashboard Bahan Bakar')
            this.timerMixpanel = setTimeout(() => {
              this.track('View Dashboard Bahan Bakar in 10 Seconds')
            }, 10000)
            break
          case 3:
            if (this.timerMixpanel) clearTimeout(this.timerMixpanel)
            this.track('View Dashboard Pengiriman')
            this.timerMixpanel = setTimeout(() => {
              this.track('View Dashboard Pengiriman in 10 Seconds')
            }, 10000)
            break
          case 4:
            if (this.timerMixpanel) clearTimeout(this.timerMixpanel)
            this.track('View Dashboard Biaya')
            this.timerMixpanel = setTimeout(() => {
              this.track('View Dashboard Biaya in 10 Seconds')
            }, 10000)
            break
        }
      }
    },
    async getCustomDashboard() {
      const res = await getCustomDashboard()

      if (res.errors) {
        this.$mcToast.error('Error get custom dashboard')
        return
      }

      if (res.data.length > 0) {
        this.customTabs = res.data.map((item) => {
          return {
            key: item.content_name.replace(' ', '-').toLowerCase(),
            hash: `#${item.content_name.replace(' ', '-').toLowerCase()}`,
            title: item.content_name,
            showTab: this.hasAccess(['custom_content:read']),
            content: CustomDashboard,
            link: item.embed_link,
            isNewSubmodule: () => {
              return false
            },
          }
        })
      }
    },
  },
}
</script>
